import { render, staticRenderFns } from "./iconDashboard.vue?vue&type=template&id=65b67a0a&scoped=true&"
import script from "./iconDashboard.vue?vue&type=script&lang=js&"
export * from "./iconDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b67a0a",
  null
  
)

export default component.exports